import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Link } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config'
import {
  urlResolverGetAccountability,
  urlResolverGetAgb,
  urlResolverGetPrivacySecurity,
} from '../../url-handling'

export const NewsletterSubscribeFormGeneralTerms: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const intl = useIntl()

  return (
    <p className="mb-7">
      {intl.formatMessage(
        {
          id: 'newsletter.subscribe.agb',
        },
        {
          agb: (chunks) => (
            <Link
              className="no-underline"
              href={urlResolverGetAgb(globalConfig)}
              rel="noreferrer"
              target="_blank"
            >
              {chunks}
            </Link>
          ),
          general_terms: (chunks) => (
            <Link
              className="no-underline"
              href={urlResolverGetAccountability(globalConfig)}
              rel="noreferrer"
              target="_blank"
            >
              {chunks}
            </Link>
          ),
          privacy: (chunks) => (
            <Link
              className="no-underline"
              href={urlResolverGetPrivacySecurity(globalConfig)}
              rel="noreferrer"
              target="_blank"
            >
              {chunks}
            </Link>
          ),
        },
      )}
    </p>
  )
}
